/// <reference path="../bower_components/jquery/dist/jquery.js" />
/// <reference path="../bower_components/slick-carousel/slick/slick.js" />
/// <reference path="../bower_components/jquery.inview/jquery.inview.js" />

function loadListingsData(data) {
    var $listingsData = $('#listings-data');
    $('#listings-data .details').jsonViewer(data);
    $('.json-dict .json-toggle').click();
    $listingsData.modal();

}

function showListingsData(listingId) {
    $('#ListingId').val(listingId);
    var $listingsData = $('#listings-data');
    if (!$listingsData.is(':visible')) {
        $.get('/search-api/debug-search-results/' + listingId, function(data) {
            var baseUrl = $('#dashboardLink').data('base-url');
            $('#dashboardLink').attr('href', baseUrl + 'Listing/Index/' + listingId);
            loadListingsData(data);
        });
    }
}

function hideListingsData() {
    var $listingsData = $('#listings-data');

    if ($listingsData.is(':visible')) {
        $listingsData.hide();
        $('body').removeClass('modal-open');
        $('#listings-data .details').text('');
    }
}

function showBugCapture() {
    var $bugCapture = $("form#bugCapture");

    if (!$bugCapture.is(':visible')) {
        $bugCapture.css('top', $(window).scrollTop());
        $bugCapture.show();
        $('body').addClass('modal-open');
    }
}


function searchResultSlickItems(selector) {
    $(selector).each(function (index, item) {
        searchResultSlick($(item));
    });
}

function loadSlides($this, imageCount) {
    var imagesRendered = parseInt($this.data('imagesrendered'));
    if (imageCount !== imagesRendered) {
        var listingId = $this.data('listingid'),
            lastWrite = $this.data('lastwrite'),
            marketingAddress = $this.data('marketingaddress');

        $this.slick('slickRemove', imagesRendered);
        for (var i = 1; i <= imageCount - 1; i++) {
            $this.slick('slickAdd', '<div class="product-media"><a href="/' + listingId + '" title="' + marketingAddress + '" class="embed-responsive embed-responsive-listing-thumbnail"><img src="https://bayleys-pri-images-cdn-endpoint.azureedge.net/listing-images/' + listingId + '/' + listingId + '_' + (i + 1) + '_HeroThumb_v2.jpg?v=' + lastWrite + '" class="embed-responsive-item" width="350" height="197" alt="' + marketingAddress + '"><span class="spinner-animated z-index-fix-n1"></span></a></div>');
        }
        $this.data('imagesrendered', imageCount);
                
        $this.slick('slickSetOption', 'infinite', true, true);
    }
}

function searchResultSlick($this) {
    if (!$this.hasClass('slick-initialized')) {
        var $parent = $this.closest('.listing'),
            imageCount = parseInt($this.data('imagecount'));
        if (imageCount >= 1) {
            $this.on('init', function (event, slick) {
                var el = $this.find('.results-player');
                var player = new Plyr(el, {
                    iconUrl: '/public/img/svg/symbol-defs.svg',
                    controls: ['play', 'progress', 'settings', 'fullscreen']
                });
                $('[data-toggle="tooltip"]').tooltip();
                $('.product-footer').matchHeight();
                $parent.addClass('in');
            });
            $this.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                dots: false,
                arrows: true,
                variableWidth: false,
                centerMode: false,
                prevArrow: '<button type="button" class="slick-prev" data-toggle="tooltip" data-placement="right" title="Previous"><svg class="svg svg-icon-arrow-left"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-arrow-left"></use></svg></button>',
                nextArrow: '<button type="button" class="slick-next" data-toggle="tooltip" data-placement="left" title="Next"><svg class="svg svg-icon-arrow-right"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-arrow-right"></use></svg></button>'
            });
            $this.on('afterChange', function (event, slick, currentSlide) {
                var listingId = $this.parents('[data-listingid]').data('listingid');
                analyticsListingImageView(listingId);
            });
            $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                loadSlides($this, imageCount);
            });
            $this.find('.slick-prev').click(function (event) {
                var imagesRendered = parseInt($this.data('imagesrendered'));
                if (imagesRendered !== imageCount) {
                    event.preventDefault();
                    loadSlides($this, imageCount);
                    $this.slick('slickPrev');
                }
            });
            $this.on('swipe', function (event, slick, direction) {
                var imagesRendered = parseInt($this.data('imagesrendered'));
                console.log(direction);
                if (direction === 'right' && imagesRendered !== imageCount) {
                    loadSlides($this, imageCount);
                    $this.slick('slickPrev');
                }
            });
            calculateFromNow();
        }
    }
}

function hideBugCapture() {
    var $bugCapture = $("form#bugCapture");
    if ($bugCapture.is(':visible')) {
        $bugCapture.hide();
        $('body').removeClass('modal-open');
    }
}

function extractErrors(jqXhr, validator) {
    var data = JSON.parse(jqXhr.responseText), // parse the response into a JavaScript object
        errors = {};

    for (var i = 0; i < data.length; i++) { // add each error to the errors object
        errors[data[i].key] = data[i].value;
    }
    validator.showErrors(errors); // show the errors using the validator object
}

function bugCapture() {
    $('#Uri').val(window.location.href);
    $('#bugCaptureSubmit').click(function() {
        $('form#bugCapture').validate();
        if ($('form#bugCapture').valid()) {
            var validator = $('form#bugCapture').validate(),
                data = $('form#bugCapture').serialize();
            $.post('bugs-api/', data)
                .done(function(data) {
                    hideBugCapture();
                })
                .error(function(jqXhr) {
                    extractErrors(jqXhr, validator);
                    console.log(jqXhr);
                });
        }
    });
    $('#bugCaptureCancel').click(function() {
        $('#ListingId').val('');
        $('#Uri').val('');
        $('#BugDetails').val('');
        hideBugCapture();
    });
}

function saveSearchButton() {
    $('.saveSearch').click(function() {
        saveSearch();
    });
}

function addToWatchlistButton() {
    $('.add-to-watch-list').click(function() {
        var el = $(this);
        if (el.hasClass("saved")) {
            deleteFromWatchListButton(el);
        } else {
            addToWatchList(el);
        }
    });
}

function sortingSearchResults() {
    $('.search-results-sorting').multiselect({
        buttonClass: 'btn btn-sm btn-white'
    });
}


function slickResultsWhenVisible() {
    $('.slick-carousel').on('inview', function (event, isInView) {
        if (isInView) {
            var $this = $(this);
            searchResultSlick($this);
            $this.off('inview');
        }
    });
}

function showImagesWhenVisible() {
    $('#results [data-src]').on('inview', function (event, isInView) {
        if (isInView) {
            var $this = $(this);
            $el = $(this);
            $el.attr('src', $el.data('src'));
            $el.removeData('src');
            $this.off('inview');
        }
    });
}

function initializeSearchResults() {
    slickResultsWhenVisible();
    showImagesWhenVisible();
    //bugCapture();
    saveSearchButton();
    addToWatchlistButton();
    sortingSearchResults();
}
